<script lang="ts" setup>
import { useValidation } from "@/composables/useValidation";
import { computed } from "vue";
import { phoneMask } from "@/data/mask";

const phoneLength = 11;

const model = defineModel<string | null>({ default: null });
const props = withDefaults(
  defineProps<{
    label: string;
    required?: boolean;
  }>(),
  {
    required: false,
  },
);

const { requiredValidator, phoneValidator } = useValidation();

const mask = phoneMask;

const normalizedModel = computed<string | null>({
  get() {
    if (!model.value) {
      return model.value;
    }

    const digits = model.value.replace(/\D/g, "");

    if (digits.length === phoneLength && digits.startsWith("1")) {
      return digits.slice(1);
    }

    return model.value;
  },
  set(value) {
    model.value = value;
  },
});

const rules = computed(() => {
  const result = [phoneValidator(model.value || "")];

  if (props.required) {
    result.push(requiredValidator(model.value || ""));
  }

  return result;
});
</script>

<template>
  <v-text-field
    v-model="normalizedModel"
    v-maska:[phoneMask]
    :class="{
      required: props.required,
    }"
    :label="props.label"
    :rules="rules"
    autocomplete="off1"
    color="primary"
    density="compact"
    hide-details="auto"
    variant="outlined"
  />
</template>
